import { LdtAppRepository } from '@ldt/api/app_repository';
import { GraphqlClient } from 'src/api/graphql_client';
import {
  EffectiveOrganizationDocument,
  EffectiveOrganizationQuery,
  OrganizationFieldsFragment,
  OrganizationListFieldsFragment,
  OrganizationsDocument,
  OrganizationsQuery,
} from 'src/types';

/**
 * Implementation of the App Repository for the Ldt platform on a GraphQL backend.
 */
export class LdtGraphqlAppRepository implements LdtAppRepository {
  constructor(private readonly _graphqlClient: GraphqlClient) {}

  async getOrganizations(): Promise<OrganizationListFieldsFragment[]> {
    const response = await this._graphqlClient.request<OrganizationsQuery>(
      OrganizationsDocument,
    );

    return response.auth0.organizations;
  }

  async getEffectiveOrganization(): Promise<OrganizationFieldsFragment> {
    const response =
      await this._graphqlClient.request<EffectiveOrganizationQuery>(
        EffectiveOrganizationDocument,
      );

    return response.auth0.effectiveOrganization;
  }
}
